<template>
  <v-card
    tile
    :loading="isLoading"
  >
    <v-card-text class="pa-2">
      <div class="d-flex flex-no-wrap justify-space-between">
        <div class="subtitle-2 grey--text text--darken-2">
          <v-icon color="success" small v-if="document.process === 3">mdi-truck-check
          </v-icon>
          {{_getDocumentTitle(document.name)}} {{document.doc_id}}
          <v-icon color="accent" small v-if="document.products">mdi-laptop</v-icon>
        </div>
        <div class="caption grey--text">{{document.created_on}}</div>
      </div>
      <div class="grey--text text--darken-1 font-weight-medium body-2">{{document.kontragenti_name}} <span v-if="document.manager" class="grey--text">({{document.manager}})</span></div>
      <div class="d-flex flex-no-wrap justify-start pt-2">
        <v-icon left :color="document.address ? 'accent' : 'grey'">{{document.address ? 'mdi-map-marker' :
          'mdi-map-marker-off'}}
        </v-icon>
        <div class="caption"
             :class="{'grey--text text--darken-1' : !document.address, 'accent--text' : document.address}">
          {{document.address || 'Адрес не указан. Уточните у менеджера.'}}
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        icon
        color="primary"
        @click="setProcess(document,document.process === 2 ? 3 : 2)"
      >
        <v-icon>{{document.process === 2 ? 'mdi-download' : 'mdi-cancel'}}</v-icon>
      </v-btn>
      <v-btn
        :disabled="document.process === 2"
        icon
        color="primary"
        @click="setProcess(document, 5)"
      >
        <v-icon>mdi-upload</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-menu
        v-if="document.managers && document.managers.length"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            color="primary"
            v-on="on"
          >
            <v-icon>mdi-account-tie</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(manager, index) in document.managers"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>{{ manager.name }}</v-list-item-title>
              <v-list-item-subtitle><a :href="`tel:${manager.phone}`">{{ manager.phone }}</a>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        icon
        color="primary"
        @click="openDocument(document)"
      >
        <v-icon>mdi-file-eye</v-icon>
      </v-btn>
      <v-btn
        icon
        color="primary"
        @click="openComment(document)"
      >
        <v-icon>mdi-comment</v-icon>
      </v-btn>
      <v-btn
        icon
        color="primary"
        @click="openPayment(document)"
      >
        <v-icon>mdi-cash-100</v-icon>
      </v-btn>
    </v-card-actions>
    <document
      ref="document"
    />
    <comment
      ref="comment"
    />
    <payment
      ref="payment"
      @setProcess="setProcess"
    />
  </v-card>
</template>

<script>
import DocumentApi from 'app/document/api'
import document from 'app/document/components/document'
import comment from 'app/document/components/comment'
import payment from 'app/document/components/payment'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'documentCard',
  components: {
    document,
    comment,
    payment
  },
  props: {
    document: {
      type: Object
    },
    currencies: {
      type: Array
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('minsk', {
      _getDocumentTitle: 'getDocumentTitle'
    }),
    ...mapFields('tradle', {
      _messageBar: 'messageBar',
      _messageText: 'messageText',
      _messageType: 'messageType'
    })
  },
  methods: {
    openDocument (document) {
      this.$refs.document.open(document)
    },
    openComment (document) {
      this.$refs.comment.open(document)
    },
    openPayment (document, k_oplate = 0) {
      this.$refs.payment.open(document, this.currencies, k_oplate)
    },
    async setProcess (document, process = 3, unloadAnyway = 0) {
      try {
        this.isLoading = true
        let response = await DocumentApi.setProcess({
          doc_id: document.doc_id,
          skladi_id: document.skladi_id,
          name: document.name,
          process: process,
          unload_anyway: unloadAnyway
        })
        if (response.process) {
          document.process = response.process
        }
        if (document.process === 5) {
          this.$emit('removeCard', response.skladi_id, response.doc_id, response.name)
        }
        if (response.k_oplate) {
          this.openPayment(document, response.k_oplate)
          this._messageBar = false
          this.isLoading = false
        } else {
          this._messageBar = false
          this._messageType = response.success ? 'success' : 'error'
          this._messageText = response.message
          this._messageBar = true
          this.isLoading = false
        }
      } catch (e) {
        this._messageBar = false
        this._messageType = 'error'
        this._messageText = e
        this._messageBar = true
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
